import { render } from "./Geography.vue?vue&type=template&id=743c648a"
import script from "./Geography.vue?vue&type=script&lang=js"
export * from "./Geography.vue?vue&type=script&lang=js"

import "./Geography.vue?vue&type=style&index=0&id=743c648a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__